import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API });

export const getDrivers = () => http.get("/drivers").then((r) => r.data);
export const updateDriver = (id, data) => http.put(`/drivers/${id}`, data).then((r) => r.data);
export const getSettings = () => http.get("/settings").then((r) => r.data);
export const updateSettings = (matching_radius_km) =>
  http.put("/settings", { matching_radius_km }).then((r) => r.data);
export const postIntake = (payload) => http.post("/intake", payload).then((r) => r.data);
export const getOffers = (limit = 50) => http.get(`/offers?limit=${limit}`).then((r) => r.data);
export const deleteOffer = (id) => http.delete(`/offers/${id}`).then((r) => r.data);
export const clearOffers = (onlyMatched = false) =>
  http.delete(`/offers?only_matched=${onlyMatched}`).then((r) => r.data);
export const getVapidKey = () => http.get("/push/vapid-public-key").then((r) => r.data.public_key);
export const subscribePush = (subscription) =>
  http.post("/push/subscribe", { subscription }).then((r) => r.data);
export const testPush = () => http.post("/push/test").then((r) => r.data);

export const getMailboxes = () => http.get("/mailboxes").then((r) => r.data);
export const addMailbox = (data) => http.post("/mailboxes", data).then((r) => r.data);
export const deleteMailbox = (id) => http.delete(`/mailboxes/${id}`).then((r) => r.data);
export const testMailbox = (id) => http.post(`/mailboxes/${id}/test`).then((r) => r.data);
export const pollEmailNow = () => http.post("/email/poll-now").then((r) => r.data);

export const getWhatsAppStatus = () => http.get("/whatsapp/status").then((r) => r.data);
export const getWhatsAppQR = () => http.get("/whatsapp/qr").then((r) => r.data);
export const logoutWhatsApp = () => http.post("/whatsapp/logout").then((r) => r.data);
export const resetWhatsApp = () => http.post("/whatsapp/reset").then((r) => r.data);
export const replyWhatsApp = (jid, text) =>
  http.post("/whatsapp/reply", { jid, text }).then((r) => r.data);

export const getWaChat = (convKey) =>
  http.get(`/whatsapp/chat/${encodeURIComponent(convKey)}`).then((r) => r.data);

export const markChatRead = (conv_key) => http.post("/chat/read", { conv_key }).then((r) => r.data);

export const replyEmail = (offer_id, text) =>
  http.post("/email/reply", { offer_id, text }).then((r) => r.data);
